import {
  Box, Button, FormField, Grid,
} from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import useOrderItemTask, { useOrderItemTaskForm } from '@hooks/useOrderItemTask'

import DateSelectFieldWithDeadlines from '@components/DateSelectFieldWithDeadlines'

import type { OrderItemTaskModel } from '@models/types'

import type { ValidateOrderItemError } from '@functions/orderItem'

import TaskInstallationImage from '@components/TaskInstallationImage'
import Errors from '../../Errors'
import ItemHeader from '../ItemHeader'

interface TaskProps {
  errors: ValidateOrderItemError[],
  orderItemTask: OrderItemTaskModel,
}

const Task = (props: TaskProps) => {
  const {
    errors,
    orderItemTask,
  } = props

  const taskPayload = useOrderItemTask(orderItemTask)
  const {
    callbacks: {
      updateOrderItemTask: updateFn,
    },
    orderItem,
    provider,
    orderItemTaskType: { title: taskTypeTitle },
    updating,
  } = taskPayload

  const formPayload = useOrderItemTaskForm(orderItemTask)
  const {
    entityState,
    entityState: {
      address,
      due_date,
      instructions,
    },
    handlers,
    saveEnabled,
    setEntityState,
  } = formPayload

  const updateOrderItemTaskPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Task Updated',
  }

  return (
    <Box borderTop="1px solid" borderColor="lineColor" flexDirection="column" padding="large">
      <ItemHeader errors={errors} title={`Task - ${taskTypeTitle}`} />

      <Errors errors={errors} />

      {/*
       // @ts-expect-error TS2322 */}
      <Grid gridGap="large" gridTemplateColumns="repeat(2, 1fr)" marginTop="large">
        <FormField label="* Task Address">
          <input name="address" value={address} type="text" {...handlers} />
        </FormField>

        <FormField label="* Task Date">
          <DateSelectFieldWithDeadlines
            callbacks={{
              onChange: formattedDate => setEntityState({ due_date: formattedDate }),
            }}
            // @ts-expect-error TS2740
            provider={provider}
            // @ts-expect-error TS2339
            serviceId={orderItem.service_id}
            value={due_date}
          />
        </FormField>

        <FormField label="* Task Instructions">
          {/*
           // @ts-expect-error TS2322 */}
          <textarea
            name="instructions"
            placeholder="Please include detailed instructions"
            style={{ height: 140 }}
            value={instructions}
            {...handlers}
          />
        </FormField>

        <TaskInstallationImage orderItemTask={orderItemTask} />
      </Grid>

      <Box
        borderTop="1px dashed"
        borderColor="lineColor"
        justifyContent="flex-end"
        marginTop="large"
        paddingTop="large"
      >
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          loadingBubbleColor="white"
          onClick={() => handleCallbackAction(updateOrderItemTaskPayload)}
          size="medium"
          width="auto"
        >
          Save Task
        </Button>
      </Box>
    </Box>
  )
}

export default Task
